import { ComponentProps, useRef } from "react";
import { MFE, Page, getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";

/** Same path on the chat MFE host and in this SPA (router + nav). */
const RUN_X_RADAR_PATH = "/run-x-radar-redirect";

const useRunxRadarRedirectAdapter = (): ComponentProps<typeof IFrame> => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const chatConfig = getMFEConfig("chat" as MFE, "chat" as Page);
  const basePath = chatConfig.iFrameUrl;
  const origin = basePath.replace(/\/?$/, "");
  const src = `${origin}${RUN_X_RADAR_PATH}`;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(ref, "Chat", RUN_X_RADAR_PATH);
  return {
    ref,
    basePath: staticSrc,
    src,
    title: "RunX Radar",
  };
};

export { useRunxRadarRedirectAdapter };
